( function($) {
  $('.wp-block-accordion-child').each(function() {
    // Initially hide all accordion contents
    $(this).find('.wp-block-accordion-child__content').hide();

    // Add click event to each accordion title
    $(this).find('.wp-block-accordion-child__title.has-content').click(function() {
      // Collapse all other accordion items
      $(this).closest('.wp-block-accordion').find('.wp-block-accordion-child').not($(this).parents('.wp-block-accordion-child')).removeClass('active').find('.wp-block-accordion-child__content').slideUp();

      // Toggle the clicked accordion item
      $(this).parents('.wp-block-accordion-child').toggleClass('active').find('.wp-block-accordion-child__content').slideToggle();
    });
  });
} )(jQuery);
